// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"19a5506f19df079e3812","1656":"05d90ab05fafdbaeed35","2983":"1f728bb13d4fd80b6bef","3485":"b3e801849a79b5a466ec","6127":"1de3ccb45fe0f97ce88e","9279":"460048c8db22e016b900"}[chunkId] + "";
};